
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "export--import-audits"
    }}>{`Export & Import Audits`}</h1>
    <h4 {...{
      "id": "background"
    }}>{`Background`}</h4>
    <p>{`The new audits for Export and Import operations also have corresponding REST APIs to programmatically fetch the audit entries.`}</p>
    <h4 {...{
      "id": "rest-apis"
    }}>{`REST APIs`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Title`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Replication Audits for a Cluster`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Example`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`URL`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api/atlas/admin/expimp/audit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`URL Parameters`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`sourceClusterName`}</em>{`: Name of source cluster.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`targetClusterName`}</em>{`: Name of target cluster.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`userName`}</em>{`: Name of the user who initiated the operation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`operation`}</em>{`: EXPORT or IMPORT operation type.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`startTime`}</em>{`: Time, in milliseconds, when operation was started.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`endTime`}</em>{`: Time, in milliseconds, when operation ended.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`limit`}</em>{`: Number of results to be returned`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`offset`}</em>{`: Offset`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Data Parameters`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`None`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Success Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of `}<em parentName="td">{`ExportImportAuditEntry`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors Returned as AtlasBaseException`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Notes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`None`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "curl"
    }}>{`CURL`}</h5>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`
curl -X GET -u admin:admin -H "Content-Type: application/json" -H "Cache-Control: no-cache"
http://localhost:port/api/atlas/admin/expimp/audit?sourceClusterName=cl2
`}
    </SyntaxHighlighter>
    <h5 {...{
      "id": "response"
    }}>{`RESPONSE`}</h5>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "queryType": "BASIC",
    "searchParameters": {
        "typeName": "ReplicationAuditEntry",
        "excludeDeletedEntities": false,
        "includeClassificationAttributes": false,
        "includeSubTypes": true,
        "includeSubClassifications": true,
        "limit": 100,
        "offset": 0,
        "entityFilters": {
            "attributeName": "name",
            "operator": "eq",
            "attributeValue": "cl2",
            "criterion": []
        }
    },
    "entities": [{
        "typeName": "ReplicationAuditEntry",
        "attributes": {
            "owner": null,
            "uniqueName": "cl2:EXPORT:1533037289411",
            "createTime": null,
            "name": "cl2",
            "description": null
        },
        "guid": "04844141-af72-498a-9d26-f70f91e8adf8",
        "status": "ACTIVE",
        "displayText": "cl2",
        "classificationNames": []
    }, {
        "typeName": "ReplicationAuditEntry",
        "attributes": {
            "owner": null,
            "uniqueName": "cl2:EXPORT:1533037368407",
            "createTime": null,
            "name": "cl2",
            "description": null
        },
        "guid": "837abe66-20c8-4296-8678-e715498bf8fb",
        "status": "ACTIVE",
        "displayText": "cl2",
        "classificationNames": []
    }]
}`}
    </SyntaxHighlighter>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;